var exports = {
  "V": "xe533113f--bf0c7a--preview",
  "v": "xe533113f--bf0c7a--inner",
};

module.exports = exports;
